import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'components.Review.title',
    defaultMessage: 'Review Your Order',
  },
  itemProductHeader: {
    id: 'shop.cart.columnTitleProduct',
    defaultMessage: 'Product',
  },
  itemPriceHeader: {
    id: 'shop.cart.columnTitlePrice',
    defaultMessage: 'Price',
  },
  itemQuantityHeader: {
    id: 'shop.cart.columnTitleQuantity',
    defaultMessage: '#',
  },
  itemTotalHeader: {
    id: 'shop.cart.columnTitleTotal',
    defaultMessage: 'Total',
  },
  subtotal: {
    id: 'shop.cart.subtotal',
    defaultMessage: 'Subtotal',
  },
  grandTotal: {
    id: 'shop.cart.grandTotal',
    defaultMessage: 'Order Total',
  },
  shippingHandling: {
    id: 'common.titles.shippingHandling',
    defaultMessage: 'Shipping & Handling',
  },
  continue: {
    id: 'common.buttons.continue',
    defaultMessage: 'Continue',
  },
  billingTitle: {
    id: 'common.titles.billingAddress',
    defaultMessage: 'Billing address',
  },
  shippingTitle: {
    id: 'common.titles.shippingAddress',
    defaultMessage: 'Shipping address',
  },
  shippingMethod: {
    id: 'common.titles.shippingMethod',
    defaultMessage: 'Shipping method',
  },
  backAddress: {
    id: 'components.Delivery.back',
    defaultMessage: 'Back to edit address',
  },
  backShipping: {
    id: 'components.Review.backShipping',
    defaultMessage: 'Back to shipping method',
  },
  discount: {
    id: 'shop.cart.discountLabel',
    defaultMessage: 'Discount',
  },
  appliedTax: {
    id: 'shop.cart.appliedTax',
    defaultMessage: 'Plus tax',
  },
  exTax: {
    id: 'shop.cart.ExTax',
    defaultMessage: 'Excl. Tax',
  },
  inclTax: {
    id: 'shop.cart.IncTax',
    defaultMessage: 'Incl. Tax',
  },
  termsError: {
    id: 'components.Review.termsError',
    defaultMessage: 'Please check all the checkboxes if you want to proceed.',
  },
});
